.container ul {
    height: 264px;
    overflow-y: auto;
}

.funnel-row {
    padding: 5px 10px;
    border-bottom: 1px solid var(--off-white-dk);
}
